<template>
  <div class="st-panel-list">
    <div class="panel-list-wrapper">
      <panel v-for="(panel, index) in attributes.value" :key="`panel-${index}`" :attributes="panel" />
    </div>
  </div>
</template>

<script>
import {store} from './ProjectStore.js'
import Panel from './Panel.vue'
import OverlayMask from './Panel.vue'

export default {
  props: ['attributes'],
  components: {Panel},
  created() {
    store.panelList = this.attributes.value
  }
}
</script>

<style lang="scss">
.st-panel-list {
  .panel-list-wrapper {
    @include grid_template(1);
    column-gap: 40px;
    @media (min-width: $d_small) {
      @include grid_template(2);
    }
    & > * {
      margin-bottom: 40px;
    }
    @supports (row-gap: 40px) {
      row-gap: 40px;
      & > * {
        margin-bottom: 0;
      }
    }
  }
}
</style>